import Grid from "@material-ui/core/Grid"
import FormControl from "@material-ui/core/FormControl"
import TextField from "@material-ui/core/TextField"
import InputLabel from "@material-ui/core/InputLabel"
import Typography from "@material-ui/core/Typography"
import React, { Fragment, useContext } from "react"
import BoardConfirmModal from "../ConfirmModal/BoardConfirmModal"
import ChargePerson from "../ChargePerson"
import FieldSelect from "../../Table/FieldSelect"
import { useCreateWeChat } from "./hooks"
import { useWeChatModalStyle } from "./style"
import { AppContext } from "Views/Home/context"

const WeChatCreate = () => {
    const classes = useWeChatModalStyle()
    const {
        callback, cancelCallback,
        dialogData, disabled, dateStr,
        text, handleChange,
        projectId, handleProjectIdChange,
        projectMoney, handleProjectMoneyChange,
        handleChangeArticleType,
        handleChangeAuthor,
        staticArticleType,
        isBusiness
    } = useCreateWeChat()
    const { roleMap } = useContext(AppContext)
    const { isTrueEditor, isOpEditor } = roleMap
    const isThreeDay = dialogData.date.getTime() - new Date().getTime() < 2 * 24 * 3600 * 1000
    return (
        <Fragment>
            <BoardConfirmModal
                title="创建预约"
                confirmCallback={callback}
                cancelCallback={cancelCallback}
                modalShow={dialogData.show}
                disabled={disabled}
            >
                <div className={classes.timeBlock}>
                    {dateStr}
                </div>
                <Grid item>
                    <TextField
                        label="内容"
                        value={text}
                        onChange={handleChange}
                        className={classes.input}
                    />
                </Grid>
                <Grid item>
                    <FormControl className={classes.input}>
                        <InputLabel >文章类型</InputLabel>
                        <FieldSelect
                            staticValueList={staticArticleType}
                            tableName="article_type"
                            onChange={handleChangeArticleType}
                            // 2026-03 文章类型=“说明” 仅编辑部主编可预约
                            whereQuery={`where: {hidden: {_eq: false}${!isTrueEditor ? ', name: {_neq: "说明"}' : ''}}`}
                        />
                    </FormControl>
                </Grid>
                {/*除编辑部主编和编辑部运营外的角色在预约微信点位时，不再需要填写“负责人”*/}
                {(isTrueEditor || isOpEditor) && (
                    <Grid item>
                        <FormControl className={classes.input}>
                            <InputLabel>负责人</InputLabel>
                            <ChargePerson handleChangeAuthor={handleChangeAuthor} />
                        </FormControl>
                    </Grid>
                )}

                {
                    // 创建时，只对商务部展示项目编号及项目金额
                    isBusiness ? (
                        <>
                            <Grid container direction="column" justify="center" className={classes.input}>
                                <TextField
                                    label="项目编号"
                                    value={projectId}
                                    onChange={handleProjectIdChange}
                                    error={!!(projectId && projectId.length > 50)}
                                    helperText={!!(projectId && projectId.length > 50) ? '最多50英文字符' : undefined}
                                />
                            </Grid>
                            <Grid container direction="column" justify="center" className={classes.input}>
                                <TextField
                                    label="项目金额"
                                    value={projectMoney}
                                    onChange={handleProjectMoneyChange}
                                    error={!!(projectMoney && projectMoney.length > 50)}
                                    helperText={!!(projectMoney && projectMoney.length > 50) ? '最多50英文字符' : undefined}
                                />
                            </Grid>
                        </>
                    ) : null
                }
                {
                    isBusiness && isThreeDay ? (
                        <>
                            <Grid container justify="flex-start" alignItems="center" className={classes.input}>
                                    <Typography color="initial">
                                        注意：3天内的预约不能修改/删除哦~
                                    </Typography>
                            </Grid>
                        </>
                    ) : null
                }
            </BoardConfirmModal>
        </Fragment>
    )
}

export default WeChatCreate
